import React from 'react';
import '../css files/Projects.css'// Import your CSS file
import logo1 from '../img/premierleagueapp.png';
import logo2 from '../img/weatherapp.png';
import logo3 from '../img/robot.jpg';
import logo4 from '../img/to-do-list.png';
import logo5 from '../img/flashcards.png';
import logo6 from '../img/simulation.jpg';

const projects = [
  {
    id: 1,
    title: 'Premier League App',
    description: 'A full stack web app for tracking Premier League football scores and statistics which utilizes the mern stack.',
    image: logo1,
    detailsLink: 'https://github.com/maahmed24712/premier-league-app',
  },
  {
    id: 2,
    title: 'Weather App',
    description: 'A weather forecasting app that provides current weather conditions and forecasts.',
    image: logo2,
    detailsLink: 'https://github.com/maahmed24712/Weather-App',
  },
  {
    id: 3,
    title: 'Arduino-Sumo-Robot',
    description: 'An autonomous sumo robot meticulously crafted and coded in C++',
    image: logo3,
    detailsLink: 'https://github.com/maahmed24712/Arduino-Sumo-Robot',
  },
  {
    id: 4,
    title: 'To-Do List App',
    description: 'A task management app for organizing your daily tasks and activities.',
    image: logo4,
    detailsLink: 'https://github.com/maahmed24712/To-do-list',
  },
  {
    id: 5,
    title: 'Flashcards App',
    description: 'An app for creating and studying flashcards to enhance your learning.',
    image: logo5,
    detailsLink: 'https://github.com/maahmed24712/Flashcard-WebApp',
  },
  {
    id: 6,
    title: 'Network Simulator',
    description: 'A project that simulates a real-world computer network and analyses the performance.',
    image: logo6,
    detailsLink: 'https://github.com/maahmed24712/Comparison-of-Manet-Routing-Protocols',
  },
];

function Portfolio() {
  return (
    <div className="portfolio">
      <h1>Projects</h1>
      <section className="projects">
        <div className="project-grid">
          {projects.map((project) => (
            <div className="project" key={project.id}>
              <img src={project.image} alt={project.title} />
              <h3>{project.title}</h3>
              <p>{project.description}</p>
              <a href={project.detailsLink} target='blank'>Learn More</a>
            </div>
          ))}
        </div>
      </section>
      <footer>
        <p>&copy; {new Date().getFullYear()} Mohamed</p>
      </footer>
    </div>
  );
}

export default Portfolio;